import { AuthorizationRequest } from '../types/AuthorizationRequest';

export const defaultAuthorizationRequest: AuthorizationRequest = {
  clientId: 1,
  redirectUri: 'https://stg-knowledge.smsc-nsc.com',
  state: 'state',
  nonce: 'nonce',
};
